import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const GlobalLeaderboard = () => {
  const [globalLeaderboard, setGlobalLeaderboard] = useState([]);

  useEffect(() => {
    const fetchGlobalLeaderboard = async () => {
      try {
        const response = await fetch("http://localhost:5001/api/games/global-leaderboard");
        
        if (!response.ok) {
          console.error("Error fetching global leaderboard:", response.statusText);
          return;
        }

        const data = await response.json();
        setGlobalLeaderboard(data);
      } catch (error) {
        console.error("Error fetching global leaderboard:", error);
      }
    };

    fetchGlobalLeaderboard();
  }, []);

  return (
    <div className="leaderboard-container">
      <header>
        <h1>Global Leaderboard</h1>
      </header>

      <main>
        {globalLeaderboard.length > 0 ? (
          <ul>
            {globalLeaderboard.map((entry) => (
              <li key={entry._id}>
                {entry.user.username}: {entry.score} points
              </li>
            ))}
          </ul>
        ) : (
          <p>No global leaderboard data available yet.</p>
        )}
      </main>

      <footer>
        <p>© 2025 Unfamiliar Games. All rights reserved.</p>
        <Link to="/" className="home-btn">
          Go Back to Home
        </Link>
      </footer>
    </div>
  );
};

export default GlobalLeaderboard;